/* eslint-disable no-console */
// eslint-disable-next-line import/no-extraneous-dependencies
import '@firebase/messaging';
import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Message } from 'semantic-ui-react';

import CdnImage from '../../components/CdnImage';
import store from '../../shared/Store';
import notificationsService from '../services/notifications.service';

const ToastMessage = ({ title, body, icon, link }) => (
  <Message
    as={link ? Link : undefined}
    to={link}
    style={{ background: 'transparent', border: 0, boxShadow: 'none', display: 'table-row' }}
  >
    {icon && (
      <CdnImage
        src={icon}
        maxHeight={48}
        style={{ display: 'table-cell', verticalAlign: 'top', width: 48, minWidth: 48 }}
      />
    )}
    <div style={{ display: 'table-cell', paddingLeft: 8, verticalAlign: 'top' }}>
      <Message.Header as="h4">{title}</Message.Header>
      <p style={{ whiteSpace: 'pre-line' }}>{body}</p>
    </div>
  </Message>
);

function showToast(title, body, options = {}) {
  const { requireInteraction } = options;
  toast(<ToastMessage title={title} body={body} {...options} />, {
    position: 'top-right',
    autoClose: requireInteraction ? 12000 : 6000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}

async function initMessaging(messaging) {
  window.messaging = messaging;
  // messaging.use
  try {
    const currentToken = await messaging.getToken({
      vapidKey:
        'BOhX8nq4AMgCKqAPuLM4GOjEKiutxarRAZ9j4IZ7LuhDTj5Ids3A08-vxlANVrjH0-AkuRDmkXwiV-wxKw_75E8',
    });

    if (store.impersonator) {
      return;
    }

    if (currentToken) {
      // Send the token to your server and update the UI if necessary
      store.firebaseToken = currentToken;

      const res = await notificationsService.registerToken(currentToken);
      console.log('res', res);
    } else {
      console.log('No registration token available. Request permission to generate one.');
    }
  } catch (e) {
    console.warn('ERROR', e);
  }

  messaging.onMessage((payload) => {
    const { notification } = payload;
    console.log('Message received. ', payload);
    if (notification) {
      showToast(notification.title, notification.body, {
        icon: notification.icon,
        link: notification.click_action,
        requireInteraction: notification.requireInteraction,
      });
      if (window.onNotification) {
        window.onNotification(payload.notification);
      }
    }
  });
}

export async function initNotifications(firebase) {
  const { firebaseServiceWorker } = window.__DATA__.endpoints;
  if (!firebaseServiceWorker) {
    console.log('No firebaseServiceWorker');
    return; // Nothing to do
  }

  // setTimeout(() => {
  //   toast(
  //     <div>
  //       <Header as="h3">Long title that will break everything</Header>
  //       <p>Lorem ipsum why not</p>
  //     </div>,
  //     {
  //       position: 'top-right',
  //       autoClose: 6000,
  //       hideProgressBar: true,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //     },
  //   );
  // }, 1000);

  if ('serviceWorker' in navigator) {
    // Register a service worker hosted at the root of the
    // site using the default scope.
    navigator.serviceWorker.register(firebaseServiceWorker).then(
      function (registration) {
        const messaging = firebase.messaging();
        messaging.useServiceWorker(registration);
        initMessaging(messaging);
      },
      function (error) {
        console.log('Service worker registration failed:', error);
      },
    );
  } else {
    console.log('Service workers are not supported.');
  }
}
